"use strict";

export function initInScope($scope) {
    let $starsWrappers = $scope.find('.js-rating-stars');
    $starsWrappers.each(function () {
        let $starsWrapper = $(this);
        let $ratingStars = $starsWrapper.find('.js-rating-star');
        $ratingStars.removeClass('is-selected');
        $ratingStars.filter(':checked').addClass('is-selected');

        $ratingStars.on('click', function (evt) {
            let $this = $(this);
            $ratingStars.removeClass('is-selected');
            $this.addClass('is-selected');

            let $chooserStars = $starsWrapper.find('.js-chooser');
            $chooserStars.addClass('is-clicked');
            setTimeout(function() {
                $chooserStars.removeClass('is-clicked');
            }, 300);
        });
    });

}